import { createSelector } from 'reselect';

const DEFAULT_ROLES = ['owner', 'manager', 'regular', 'client'];

const getRole = (roles, roleId) => roles.find(role => role.id === roleId);
export const makeGetRole = () => createSelector(getRole, roles => roles);

const getRoles = roles => roles
    .filter(role => role && !role.removed)
    .sort((l1, l2) => {
        const l1Index = l1.default ? DEFAULT_ROLES.indexOf(l1.name) : (l1.name || '').toLowerCase();
        const l2Index = l2.default ? DEFAULT_ROLES.indexOf(l2.name) : (l2.name || '').toLowerCase();

        if (l1.default && !l2.default) {
            return -1;
        }

        if (l2.default && !l1.default) {
            return 1;
        }

        if (l1Index > l2Index) return 1;
        if (l1Index < l2Index) return -1;

        return 0;
    });
export const makeGetRoles = () => createSelector(getRoles, roles => roles);
